
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"20","viewBox":"0 0 15 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.372 10c0 2.761 2.124 5 4.744 5a4.56 4.56 0 002.75-.924l.565.596a5.328 5.328 0 01-3.315 1.161c-3.057 0-5.535-2.611-5.535-5.833 0-.46-.354-.833-.79-.833C.354 9.167 0 9.54 0 10c0 3.86 2.768 7.04 6.327 7.454l-.001.046v.833H4.744c-.436 0-.79.373-.79.834 0 .46.353.833.79.833h4.744c.437 0 .791-.373.791-.833 0-.46-.354-.834-.79-.834H7.906V17.5l-.001-.046a6.894 6.894 0 003.652-1.594l2.092 2.205a.762.762 0 001.118 0 .865.865 0 000-1.179L1.35 2.744a.762.762 0 00-1.118 0 .865.865 0 000 1.179l2.14 2.256V10zM2.898 2.71l8.64 9.105A5.226 5.226 0 0011.861 10V5c0-2.761-2.124-5-4.744-5-1.837 0-3.43 1.1-4.219 2.71zM12.148 12.45l1.174 1.237a7.781 7.781 0 00.918-3.688c0-.46-.354-.833-.79-.833-.437 0-.791.373-.791.833 0 .875-.183 1.705-.51 2.45z"}})])
          )
        }
      }
    